export const INTEGRATION_TYPES = {
  QR: {
    value: 'QR',
    label: 'QR'
  },
  GUPSHUP: {
    value: 'GUPSHUP',
    label: 'Gupshup'
  }
};

export const MESSAGE_TYPES = [
  { label: 'messageTypes.all', value: 'all', icon: 'mi-menu-fill' },
  { label: 'messageTypes.text', value: 'text', icon: 'mi-text-icon' },
  { label: 'messageTypes.image', value: 'image', icon: 'mi-image-outline' },
  { label: 'messageTypes.documents', value: 'document', icon: 'mi-document-pdf-16-regular' },
  { label: 'messageTypes.video', value: 'video', icon: 'mi-video-outline' },
  { label: 'messageTypes.carousel', value: 'carousel', icon: 'mi-image-outline' }
];
